import { render, staticRenderFns } from "./PriceingHomeRtl.vue?vue&type=template&id=f9517b08&"
import script from "./PriceingHomeRtl.vue?vue&type=script&lang=js&"
export * from "./PriceingHomeRtl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports